import i18n from "@app/translations/i18n";
import {
  FALLBACK_LANGUAGE,
  SUPPORTED_LANGUAGES,
  TSupportedLanguages,
} from "@app/translations/i18n.interfaces";

const getLanguage = (language?: string): TSupportedLanguages => {
  if (!language) {
    language = i18n.language ?? "en";
  }
  language = language.split("-")[0];
  if (SUPPORTED_LANGUAGES.indexOf(language as TSupportedLanguages) === -1) {
    language = FALLBACK_LANGUAGE;
  }
  return language as TSupportedLanguages;
};

export default getLanguage;
